import React from "react";
import {Box, Illustration, Stack, Text} from "@mbank-design/design-system/components";
import {HandThumbUpCorporate} from "@mbank-design/design-system/illustrations";

export default function SpeakerInvitationSentConfirmation() {
    return(
        <Box minWidth={[0, 1280]}>
            <Stack>
                <Illustration illustrationComponent={HandThumbUpCorporate} />
                <Text as={"h2"}>thank you for submitting your confirmation</Text>
                <Text as={"body"}>we will contact you to clarify the details of participation in the event</Text>
            </Stack>
        </Box>
    );
}